import authAxios from "../axios/authAxios";

class DeploymentAPI {
    static getAlerts(accessToken) {
        return authAxios.get("/v2/internal-alerts/", {
            headers: { Authorization: `Bearer ${accessToken}` },
        });
    }

    static patchComplete(accessToken, alert_id) {
        return authAxios.patch(
            "/v2/internal-alerts/complete/",
            {
                id: alert_id,
            },
            { headers: { Authorization: `Bearer ${accessToken}` } }
        );
    }
}

export default DeploymentAPI;
